import { render, staticRenderFns } from "./Rotation.vue?vue&type=template&id=7b0af4c8&"
import script from "./Rotation.vue?vue&type=script&lang=ts&"
export * from "./Rotation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports